import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getOneActionPlanKey } from "../ActionPlan/useGetOneActionPlan";

type DeleteActionPlanAction = {
    actionPlanId: string | undefined;
    actionPlanActionId: string | undefined;
};

export const useDeleteActionPlanAction = () => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: DeleteActionPlanAction) => {
            const { actionPlanId, actionPlanActionId } = options;

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Deletion...",
            });

            const url = `/api/action_plans/${actionPlanId}/action/${actionPlanActionId}`;
            await loggedInApiCall.delete(url);
        },
        onSuccess: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Resource deleted",
            });
            queryClient.refetchQueries([getOneActionPlanKey]);
        },
    });

    return query;
};
